import { render, staticRenderFns } from "./LetterPreview.vue?vue&type=template&id=0a6d1dc2&scoped=true&"
import script from "./LetterPreview.vue?vue&type=script&lang=js&"
export * from "./LetterPreview.vue?vue&type=script&lang=js&"
import style0 from "./LetterPreview.vue?vue&type=style&index=0&id=0a6d1dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d1dc2",
  null
  
)

export default component.exports